import { useState } from 'react';

import { Box } from '@aicon-dev/caas-ui';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { ForgeViewer } from '~/components/ui/FileViewer/components/ForgeViewer';
import { getForgeviewerToken } from '~/components/ui/FileViewer/components/ForgeViewer/libs/utils';
import PdfViewer from '~/components/ui/FileViewer/components/PdfViewer';
import { UploadFileResponse } from '~/components/ui/Upload';

import useFileTypeCheck from '../../libs/utils/useFileTypeCheck';

interface ViewerProps {
  currentFile?: UploadFileResponse;
}

export const Viewer = (props: ViewerProps) => {
  const { currentFile } = props;
  const { t } = useTranslation('drawing');

  const [forgeView, setForgeView] = useState(null);
  const { imageFormat, forgeViewerFormat, pdftronFormat, typeChecker } = useFileTypeCheck();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleDocumentLoaded = (doc: any, viewables: any) => {
    console.log('doc >>> ', doc);
    if (viewables.length === 0) return;
    setForgeView(viewables[0]);
  };

  const renderViewer = () => {
    if (!currentFile)
      return (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          style={{ background: '#FAFAFA' }}
        >
          {t('drawing:m_please_select_the_drawing')}
        </Box>
      );

    if (typeChecker(imageFormat, currentFile?.fileExtension))
      return <img key={currentFile?._id} src={currentFile?.url} />;

    if (typeChecker(pdftronFormat, currentFile?.fileExtension))
      return <PdfViewer url={currentFile?.url || ''} />;

    if (typeChecker(forgeViewerFormat, currentFile?.fileExtension))
      return (
        <Box>
          <ForgeViewer
            version="7.61"
            urn={currentFile?.urn || ''}
            headless={false}
            view={forgeView}
            onTokenRequest={getForgeviewerToken}
            onDocumentLoad={handleDocumentLoaded}
          />
        </Box>
      );

    return (
      <Box display="flex" alignItems="center" justifyContent="center">
        {t('drawing:m_it_is_an_incorrect_file_type')}
      </Box>
    );
  };
  return (
    <>
      <Wrapper>{renderViewer()}</Wrapper>
    </>
  );
};

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: calc(100% - 108px);
  overflow: hidden;

  & > * {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  & > img {
    object-fit: contain;
  }
`;
